import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { createFolderStructureForm } from './folder-structure-form.form';

@Component({
  selector: 'temp-folder-structure-form',
  templateUrl: './folder-structure-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, ReactiveFormsModule],
})
export class FolderStructureFormComponent implements OnInit {
  form = createFolderStructureForm();
  showInvalid = false;

  @Input() initialForm: Record<string, unknown> | null = null;

  ngOnInit() {
    if (this.initialForm) {
      this.form.patchValue(this.initialForm);
    }
  }

  preventInvalid(formControl: string, event: KeyboardEvent) {
    if (event.ctrlKey || event.metaKey || event.altKey || event.key.length > 1)
      return;

    const control = this.form.get(formControl);
    const validator = control.validator;
    const input = event.target as HTMLInputElement;
    const selectionStart = input.selectionStart ?? input.value.length;
    const selectionEnd = input.selectionEnd ?? input.value.length;
    const newValue =
      input.value.substring(0, selectionStart) +
      event.key +
      input.value.substring(selectionEnd);
    const abstractControl = { ...control, value: newValue } as AbstractControl;
    const validationResult = validator(abstractControl);

    if (validationResult) {
      this.showInvalid = true;
      setTimeout(() => {
        this.showInvalid = false;
      }, 3000);
      event.preventDefault();
    } else {
      this.showInvalid = false;
    }
  }
}
